// واگذاری/جابجایی — place: ردیف مکان از صفحهٔ اماکن
import React, { useState, useEffect, useCallback } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, qs, toFa, num, curYear, Grid, Field, Box, Lookup, MessageBox, Modal, splitLines, visibleCols, runReport,
  smallBtn, DEL_ASK, PP_COLS,
} from './placeShared';

const FORM = 'FRMPROPERTYPLACE2';
const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL', 'BTNSTOCKHAVALEH', 'BTNGOODSREQUESTFROMSTOCK'];
const REC_COLS = [{ key: 'event_date', label: 'تاریخ تحویل' }, { key: 'receiver', label: 'تحویل گیرنده', wrap: true },
  { key: 'melli_code', label: 'کد ملی' }];
const PICK_COLS = [
  [{ key: 'code', label: 'کد' }, { key: 'title', label: 'عنوان', wrap: true }, { key: 'feature', label: 'ویژگی' },
    { key: 'stock', label: 'موجودی', num: true }, { key: 'confirmed_stock', label: 'موجودی تایید شده', num: true },
    { key: 'from_serial', label: 'از شماره سریال' }, { key: 'to_serial', label: 'تا شماره سریال' },
    { key: 'last_serial', label: 'آخرین سریال واگذارشده' }, { key: 'first_free', label: 'اولین شماره قابل واکذاری' },
    { key: 'm1', label: 'یک ماه اخیر', num: true }, { key: 'm2', label: 'دو ماه اخیر', num: true },
    { key: 'm3', label: 'سه ماه اخیر', num: true }, { key: 'm6', label: 'شش ماه اخیر', num: true },
    { key: 'cur_year', label: 'سال جاری', num: true }, { key: 'last_year', label: 'سال قبل', num: true }],
  [{ key: 'code', label: 'کد' }, { key: 'label_no', label: 'برچسب' }, { key: 'old_label_no', label: 'برچسب قدیم' },
    { key: 'title', label: 'عنوان', wrap: true }, { key: 'feature', label: 'ویژگی' }, { key: 'stock', label: 'موجودی', num: true },
    { key: 'remark', label: 'شرح', wrap: true }, { key: 'desc1', label: 'ویژگی 1' }, { key: 'desc2', label: 'ویژگی 2' },
    { key: 'desc3', label: 'ویژگی 3' }, { key: 'desc4', label: 'ویژگی 4' }, { key: 'uid1', label: 'ویژگی 5' },
    { key: 'uid2', label: 'ویژگی 6' }, { key: 'uid3', label: 'ویژگی 7' }, { key: 'uid4', label: 'ویژگی 8' }],
];

function PropertyPicker({ placeId, type, onPick, onClose }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const search = () => API(`/${placeId}/property-place/lookup/property/?${qs({ type, q, year: curYear() })}`)
    .then(j => setRows(j.ok ? j.data : []));
  const cols = visibleCols(PICK_COLS[type ? 1 : 0], rows);
  return (
    <Modal title="کالا" width="1100px" z={1100} onClose={onClose}>
      <div style={ui.row}>
        <input autoFocus value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && search()}
          placeholder="جستجو" style={{ ...ui.searchInput, flex: 1 }} />
        <button onClick={search} style={smallBtn}>جستجو</button>
      </div>
      <Grid columns={cols} rows={rows} onDouble={onPick} zebra="#ffe4d6" />
    </Modal>
  );
}

const EMPTY_ITEM = { property_id: 0, property: '', remark: '', from_serial: 0, to_serial: 0, quantity: '', leave_date: '' };

export default function PropertyPlace2({ user, onBack, place }) {
  const fb = useFormButtons(FORM, BUTTONS);
  const pid = place ? place.id : 0;
  const [search, setSearch] = useState('');
  const [cons, setCons] = useState(true);
  const [uncons, setUncons] = useState(true);
  const [printSigners, setPrintSigners] = useState(true);
  const [sel, setSel] = useState(null);
  const [receivers, setReceivers] = useState([]);
  const [modal, setModal] = useState(null);       // new | edit
  const [onlyRec, setOnlyRec] = useState(false);
  const [form, setForm] = useState(null);
  const [base, setBase] = useState({ stock: 0, confirmed_stock: 0, max_serial: 0 });
  const [picker, setPicker] = useState(false);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState(null);
  const [ask, setAsk] = useState(null);
  const year = curYear();

  const L = usePagedList((page, o) => API(`/${pid}/property-place/?${qs({ page, search: o.search, cons: o.cons, uncons: o.uncons })}`));
  const showMsg = m => setMsg(splitLines(m));

  const reload = useCallback((keepId, opt) => {
    L.reload(opt || { search, cons: cons ? 1 : 0, uncons: uncons ? 1 : 0 }).then(j => {
      if (!j || !j.ok) return;
      const rows = j.data || [];
      setSel((keepId && rows.find(r => r.id === keepId)) || rows[0] || null);
    });
  }, [L, search, cons, uncons]);
  useEffect(() => { if (fb.loaded && fb.open) reload(); }, [fb.loaded, fb.open]);

  const toggle = (which, v) => {
    let c = which === 'c' ? v : cons;
    let u = which === 'u' ? v : uncons;
    if (!c && !u) { if (which === 'c') u = true; else c = true; }
    setCons(c); setUncons(u);
    reload(null, { search, cons: c ? 1 : 0, uncons: u ? 1 : 0 });
  };

  useEffect(() => {
    if (!sel) { setReceivers([]); return; }
    API(`/property-place/${sel.id}/receivers/`).then(j => setReceivers(j.ok ? j.data : []));
  }, [sel]);

  const loadInfo = (propId, setSerial) => {
    if (!propId) { setBase({ stock: 0, confirmed_stock: 0, max_serial: 0 }); return; }
    API(`/property-place/property-info/${propId}/`).then(j => {
      if (!j.ok) return;
      setBase({ stock: j.stock, confirmed_stock: j.confirmed_stock, max_serial: j.max_serial });
      if (setSerial) setForm(f => ({ ...f, from_serial: j.from_serial, to_serial: 0 }));
    });
  };

  const lastReceiver = () => (receivers.length ? receivers[receivers.length - 1] : null);
  const fromRow = (r) => ({
    property_type: r ? r.property_type : 0, request_no: r ? r.request_no : '', request_date: r ? r.request_date : '',
    asker_id: r ? r.asker_id : 0, asker: r ? r.asker : '', event_date: r ? r.event_date : '',
    permission_no: r ? r.permission_no : '', goods_receiver_id: 0, goods_receiver: '',
  });

  const openNew = () => {
    setForm({ ...fromRow(sel), ...EMPTY_ITEM });
    const lr = lastReceiver();
    if (lr) setForm(f => ({ ...f, goods_receiver_id: lr.people_id, goods_receiver: lr.receiver }));
    setBase({ stock: 0, confirmed_stock: 0, max_serial: 0 });
    setOnlyRec(false); setErr(''); setModal('new');
  };
  const openEdit = async () => {
    if (!sel) return;
    const j = await API(`/property-place/${sel.id}/check-edit/`);
    if (!j.ok) { showMsg(j.msg); return; }
    if (j.only_receiver) showMsg(j.msg);
    const lr = lastReceiver();
    setForm({ ...fromRow(sel), property_id: sel.property_id, property: sel.title, remark: sel.remark,
      from_serial: sel.from_serial, to_serial: sel.to_serial, quantity: sel.quantity, leave_date: sel.leave_date,
      goods_receiver_id: lr ? lr.people_id : 0, goods_receiver: lr ? lr.receiver : '' });
    loadInfo(sel.property_id, false);
    setOnlyRec(!!j.only_receiver); setErr(''); setModal('edit');
  };

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setQty = (v) => {
    setForm(f => {
      const n = { ...f, quantity: v };
      const frm = num(f.from_serial);
      if (frm > 0) {
        let to = frm + num(v) - 1;
        if (to > base.max_serial) {
          showMsg('تعداد واگذاری با توجه به شماره سریال نامعتبر است');
          to = base.max_serial;
          n.quantity = base.max_serial - frm + 1;
        }
        n.to_serial = to;
      }
      return n;
    });
  };
  const pickProperty = (r) => {
    setPicker(false);
    setForm(f => ({ ...f, property_id: r.id, property: r.title + (r.feature ? ` - ${r.feature}` : '') }));
    loadInfo(r.id, true);
  };
  const newRequest = async () => {
    const j = await API(`/property-place/new-request/?${qs({ year })}`);
    if (j.ok) setForm(f => ({ ...f, request_no: j.request_no, request_date: j.request_date, permission_no: j.permission_no, event_date: j.event_date }));
  };

  const save = async (confirms = {}) => {
    setErr('');
    const body = JSON.stringify({ ...form, ...confirms, year });
    const j = modal === 'new' ? await API(`/${pid}/property-place/create/`, { method: 'POST', body })
      : await API(`/property-place/${sel.id}/update/`, { method: 'PUT', body });
    if (!j.ok) { if (j.msg) showMsg(j.msg); return; }
    if (j.ask) {
      setAsk({ lines: [...j.ask.lines, '', j.ask.question], onYes: () => { setAsk(null); save({ ...confirms, [j.ask.key]: 1 }); } });
      return;
    }
    if (!j.saved) return;
    if (modal === 'new') {
      setForm(f => ({ ...f, ...EMPTY_ITEM }));
      setBase({ stock: 0, confirmed_stock: 0, max_serial: 0 });
      reload(sel && sel.id);
    } else {
      setModal(null);
      reload(sel.id);
    }
  };

  const doDelete = async () => {
    setAsk(null);
    const j = await API(`/property-place/${sel.id}/delete/`, { method: 'DELETE' });
    if (j.ok) reload(); else showMsg(j.msg);
  };
  const askDelete = async () => {
    if (!sel) return;
    const j = await API(`/property-place/${sel.id}/delete/?check=1`, { method: 'DELETE' });
    if (!j.ok) { showMsg(j.msg); return; }
    setAsk({ lines: [DEL_ASK], onYes: doDelete });
  };

  const stockHavaleh = () => {
    if (!sel) return;
    const lr = lastReceiver();
    runReport('tadarokat.stock_havaleh', { place_id: pid, permission_no: sel.permission_no, event_date: sel.event_date,
      cons: cons ? 1 : 0, uncons: uncons ? 1 : 0, print_signers: printSigners ? 1 : 0, goods_receiver_id: lr ? lr.people_id : 0 }, showMsg);
  };
  const requestFromStock = () => {
    if (!sel) return;
    runReport('tadarokat.goods_request_from_stock', { place_id: pid, permission_no: sel.permission_no, event_date: sel.event_date,
      request_no: sel.request_no, request_date: sel.request_date, asker_id: sel.asker_id }, showMsg);
  };

  const shown = visibleCols(PP_COLS, L.data);
  const has = !!sel;
  const lock = onlyRec;
  const oldQty = modal === 'edit' && sel ? num(sel.quantity) : 0;
  const stockNow = form && form.property_id ? base.stock + oldQty - num(form.quantity) : 0;
  const cStockNow = form && form.property_id ? base.confirmed_stock + oldQty - num(form.quantity) : 0;

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={openNew} style={{ ...ui.btnNew, cursor: 'pointer' }}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button onClick={openEdit} disabled={!has} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4, cursor: 'pointer' }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button onClick={askDelete} disabled={!has} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4, cursor: 'pointer' }}>✕ حذف</button>}
      </div>
      {fb.can('BTNGOODSREQUESTFROMSTOCK') && <button onClick={requestFromStock} disabled={!has} style={smallBtn}>برگ درخواست از انبار</button>}
      {fb.can('BTNSTOCKHAVALEH') && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '4px 8px', fontSize: '11px' }}>
          <label><input type="checkbox" checked={cons} onChange={e => toggle('c', e.target.checked)} /> مصرفی</label>
          <label><input type="checkbox" checked={uncons} onChange={e => toggle('u', e.target.checked)} /> غیرمصرفی</label>
          <label><input type="checkbox" checked={printSigners} onChange={e => setPrintSigners(e.target.checked)} /> چاپ امضاءکنندگان</label>
          <button onClick={stockHavaleh} disabled={!has} style={smallBtn}>حواله انبار</button>
        </div>
      )}
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && reload()}
        style={{ ...ui.searchInput, flex: 1, minWidth: '160px' }} placeholder="جستجو" />
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="ردیف" />
      <ExcelButton title="واگذاری/جابجایی" subtitle={place ? place.place_name : ''} columns={shown} rows={L.data} />
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title="واگذاری/جابجایی" subtitle={place ? place.place_name : ''}
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading} unit="ردیف">
        {fb.open && (
          <div style={ui.splitWrap}>
            <div style={ui.topPane}>
              <Grid columns={shown} rows={L.data} selectedId={sel && sel.id} onSelect={setSel} loading={L.loading} />
            </div>
            <div style={{ ...ui.bottomPane, flex: '0 0 auto', minHeight: '90px' }}>
              {receivers.length > 0 && <Grid columns={REC_COLS} rows={receivers} zebra="#fffde7" />}
            </div>
          </div>
        )}
      </ListPage>

      {modal && form && (
        <Modal title="واگذاری/جابجایی" width="900px" onClose={() => setModal(null)}
          footer={<>
            {modal === 'new' && fb.can('BTNOK') && <button onClick={newRequest} style={smallBtn}>شماره درخواست جدید</button>}
            {fb.can('BTNCANCEL') && <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>}
            {fb.can('BTNOK') && <button onClick={() => save()} style={ui.btnSave}>ثبت</button>}
          </>}>
          {err && <div style={ui.errBox}>⚠️ {err}</div>}
          <div style={ui.row}>
            <Box label="نوع کالا" flex={0} minWidth="120px">
              <select value={form.property_type} disabled={lock}
                onChange={e => setForm(f => ({ ...f, property_type: Number(e.target.value), property_id: 0, property: '' }))} style={ui.input}>
                <option value={0}>مصرفی</option><option value={1}>غیرمصرفی</option>
              </select>
            </Box>
            <Box label="کالا" flex={3}>
              <div style={{ display: 'flex', gap: '6px' }}>
                <input value={toFa(form.property)} readOnly style={{ ...ui.input, background: '#f7f7f7' }} />
                {!lock && <button onClick={() => setPicker(true)} style={smallBtn}>انتخاب</button>}
                {!lock && form.property_id > 0 && <button onClick={() => setForm(f => ({ ...f, property_id: 0, property: '' }))} style={{ ...smallBtn, background: '#c62828' }}>✕</button>}
              </div>
            </Box>
          </div>
          <div style={ui.row}>
            <Field label="شماره درخواست" value={form.request_no} onChange={v => F('request_no', v)} disabled={lock} />
            <Box label="تاریخ درخواست"><JalaliDatePicker value={form.request_date} disabled={lock} onChange={v => F('request_date', v)} /></Box>
            <Lookup label="درخواست کننده" value={form.asker} endpoint="/property-place/lookup/people/" disabled={lock}
              onPick={r => setForm(f => ({ ...f, asker_id: r.id, asker: r.title }))} flex={2} />
          </div>
          <div style={ui.row}>
            <Box label="تاریخ واگذاری"><JalaliDatePicker value={form.event_date} disabled={lock} onChange={v => F('event_date', v)} /></Box>
            <Field label="شماره مجوز" value={form.permission_no} onChange={v => F('permission_no', v)} disabled={lock} />
            <Field label="تعداد" value={form.quantity} onChange={setQty} disabled={lock} />
            <Field label="شماره سریال: از" value={form.from_serial} disabled />
            <Field label="تا" value={form.to_serial} disabled />
          </div>
          <div style={ui.row}>
            <Field label="موجودی" value={toFa(stockNow)} disabled />
            <Field label="موجودی تایید شده" value={toFa(cStockNow)} disabled />
            <Field label="تاریخ خروج کالا" value={form.leave_date} disabled />
          </div>
          <div style={ui.row}>
            <Field label="توضیح" value={form.remark} onChange={v => F('remark', v)} disabled={lock} flex={2} />
            <Lookup label="تحویل گیرنده" value={form.goods_receiver} endpoint="/property-place/lookup/people/"
              onPick={r => setForm(f => ({ ...f, goods_receiver_id: r.id, goods_receiver: r.title }))} flex={2} />
          </div>
        </Modal>
      )}
      {picker && form && <PropertyPicker placeId={pid} type={form.property_type} onPick={pickProperty} onClose={() => setPicker(false)} />}
      {ask && <WarningDialog title="هشدار" lines={ask.lines} confirmLabel="بلی" cancelLabel="خیر" tone="warn"
        onConfirm={ask.onYes} onCancel={() => setAsk(null)} />}
      {msg && <MessageBox lines={msg} onClose={() => setMsg(null)} />}
    </>
  );
}
